export default __webpack_public_path__ + "static/media/cal.f900ae4d.svg";